export default __webpack_public_path__ + "static/media/olamilekan.e407b8cb.jpg";